import { makeAutoObservable, runInAction } from "mobx";
import { access_key, baseUrl, errors } from "./main";
import {
  normalizeBackendErrorPayload,
  parseFetchErrorResponse,
  pickAnyFieldError,
  safeJsonParse
} from "./apiErrorParser";

export default class CandidatesStore {
  candidates = [];
  candidatesCountAll = "";
  candidatesOnPage = 10;
  candidatesPage = 1;
  error = false;
  isLoading = false;
  isUpdateLoading = {};

  candidatesForVacancy = [];

  applications = [];
  applicationsCountAll = "";
  applicationsForCandidate = [];
  applicationsStatuses = [];

  education_centers = [];

  candidateSurname = "";
  candidateStatusesInStore = {};
  candidateStatusesNames = {};

  allcandidates = [];
  errorAddition = "";
  errorAdditionFields = {};
  success = false;

  errorMessage = "";

  errorWithoutDate = "";

  selectedVacancy = "";
  selectedCandidate = "";
  selectedCenter = "";
  selectedDate = "";

  // id отклика, который обновляем через цепочку "Обновить отклик"
  updateVacancyCandidateId = "";
  // текущие данные обновляемого отклика (для пунктов "Оставить прежний")
  updateCurrentVacancyId = "";
  updateCurrentVacancyTitle = "";
  updateCurrentCenterId = "";
  updateCurrentCenterTitle = "";
  updateCurrentDate = "";

  isLoadingForCandidates = false;

  applicationsOnPage = 20;
  applicationsPage = 1;

  openVacancies = false;

  apllicationsAccepted = [];
  applicationAcceptedId = null;
  isNewCandidate = false;
  oneCandidateData = null;
  oneCandidateFiles = null;

  statusesTitles = null;

  noCandidatesError = null;

  requiredFieldsForAdd = {};
  requiredFieldsForUpdate = {};
  requiredFiles = {};

  prevRes = 1;

  sort = "";
  sorted = "";

  filter = {
    applicationsStatuses: [], // id статусов кандидата
    vacancies: [], // id вакансий
    education_centers: [] // id УЦ
  };

  constructor(instance) {
    this.rootStore = instance;
    makeAutoObservable(this, {}, { deep: true });
  }

  setOpenVacancies = (value) => {
    this.openVacancies = value;
  };

  cleanApplications = () => {
    this.applications = "";
  };

  cleanErrorAddition = () => {
    this.errorAddition = "";
    this.errorAdditionFields = {};
  };

  clearErrorAdditionField = (field) => {
    runInAction(() => {
      if (!this.errorAdditionFields || !this.errorAdditionFields[field]) return;
      const next = { ...this.errorAdditionFields };
      delete next[field];
      this.errorAdditionFields = next;
      if (Object.keys(next).length === 0) {
        this.errorAddition = "";
      }
    });
  };

  cleanErrorWithoutDate = () => {
    this.errorWithoutDate = "";
  };

  cleanCandidates = () => {
    this.candidates = [];
  };

  setCandidateSurname = (value) => {
    this.candidateSurname = value;
  };

  setCandidateStatusesInStore = (statusID, value) => {
    this.candidateStatusesInStore[statusID] = value;
  };

  setSelectedVacancy = (value) => {
    this.selectedVacancy = value;
  };

  setSelectedCandidate = (value) => {
    this.selectedCandidate = value;
  };

  setSelectedCenter = (value) => {
    this.selectedCenter = value;
  };

  setSelectedDate = (value) => {
    this.selectedDate = value;
  };

  setUpdateVacancyCandidateId = (value) => {
    runInAction(() => {
      this.updateVacancyCandidateId = value;
      // при выходе из режима обновления чистим данные "оставить прежний"
      if (!value) {
        this.updateCurrentVacancyId = "";
        this.updateCurrentVacancyTitle = "";
        this.updateCurrentCenterId = "";
        this.updateCurrentCenterTitle = "";
        this.updateCurrentDate = "";
      }
    });
  };

  // Открывает цепочку обновления отклика: выбор вакансии -> УЦ и дата.
  // Вакансию берём из всех доступных кандидату, поэтому грузим их заново.
  startApplicationUpdate = (candidate) => {
    runInAction(() => {
      this.selectedCandidate = candidate.candidate_id;
      // по умолчанию оставляем текущие вакансию, УЦ и дату отклика
      this.selectedVacancy = candidate.vacancy_id;
      this.updateCurrentVacancyId = candidate.vacancy_id;
      this.updateCurrentVacancyTitle = candidate.vacancy_title || "";
      this.selectedCenter = candidate.education_center_id || "";
      this.updateCurrentCenterId = candidate.education_center_id || "";
      this.updateCurrentCenterTitle = candidate.education_center_title || "";
      this.updateCurrentDate = candidate.date_arrival || "";
      this.selectedDate = candidate.date_arrival
        ? new Date(candidate.date_arrival)
        : "";
      this.updateVacancyCandidateId = candidate.vacancy_candidate_id;
    });
    this.cleanErrorAddition();
    this.rootStore.vacanciesStore.getVacancies_for_candidate(
      candidate.candidate_id
    );
    this.rootStore.modalWindows.setModalShowVacancies(true);
  };

  setIsNewCandidate = (value) =>
    runInAction(() => (this.isNewCandidate = value));

  clearOneCandidate = () => {
    runInAction(() => {
      this.oneCandidateData = null;
      this.oneCandidateFiles = null;
    });
  };

  setOneCandidateFile = (name, value) => {
    runInAction(() => {
      if (!this.oneCandidateFiles) return;
      this.oneCandidateFiles = {
        ...this.oneCandidateFiles,
        [name]: value
      };
    });
  };

  setStatusIds = (array) => runInAction(() => (this.statusIds = array));

  setSort = (value) => runInAction(() => (this.sort = value));

  setSorted = (value) => runInAction(() => (this.sorted = value));

  setFilter = (key, array) => {
    runInAction(() => {
      this.filter[key] = array;
    });
  };

  setPrevRes = (value) => runInAction(() => (this.prevRes = value));

  getCandidates = async () => {
    this.isLoading = true;
    this.noCandidatesError = null;
    this.candidates = [];
    this.candidatesPage = 1;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", 1);
    bodyData.append("on_page", this.candidatesOnPage);
    bodyData.append("order", "date_create");
    bodyData.append("ordered", "DESC");

    if (this.statusIds && this.statusIds.length) {
      for (const id of this.statusIds) {
        bodyData.append("filter[status_id][]", id);
      }
    }

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.isLoading = false;
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== -1) {
            this.candidatesCountAll = response["count_all"];
            this.candidates = response["records"];
          } else {
            this.noCandidatesError = "Ничего не найдено";
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.isLoading = false;
          this.error = true;
        });
      });
  };

  showMoreCandidates = async () => {
    this.isLoadingForCandidates = true;
    this.candidatesPage = this.candidatesPage += 1;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", this.candidatesPage);
    bodyData.append("on_page", this.candidatesOnPage);
    bodyData.append("order", "date_create");
    bodyData.append("ordered", "DESC");

    if (this.statusIds && this.statusIds.length) {
      for (const id of this.statusIds) {
        bodyData.append("filter[status_id][]", id);
      }
    }

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          this.isLoadingForCandidates = false;
          this.error = true;
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["records"] !== -1) {
            this.candidatesCountAll = response["count_all"];
            this.candidates = [...this.candidates, ...response["records"]];
          }
          this.isLoadingForCandidates = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.isLoadingForCandidates = false;
          this.error = true;
        });
      });
  };

  getCandidatesForVacancy = async (data) => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", data.page);
    bodyData.append("on_page", data.on_page);
    bodyData.append("vacancy_id", data.vacancy);
    bodyData.append("order", "date_create");
    bodyData.append("ordered", "DESC");

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=candidates_for_vacancy`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
      })
      .then((response) => {
        runInAction(() => {
          response["candidates"] !== -1
            ? (this.candidatesForVacancy = response["candidates"])
            : (this.candidatesForVacancy = []);
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.isLoading = false;
        });
      });
  };

  getApplicationsForVacancy = async (data) => {
    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", data.page);
    bodyData.append("on_page", data.on_page);
    bodyData.append("vacancy_id", data.vacancy);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies_candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => { });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["vacancies_candidates"] !== -1) {
            this.applications = response["vacancies_candidates"];
          }
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  getApplications = async () => {
    this.isLoading = true;
    this.applications = [];
    this.errorMessage = "";
    this.applicationsPage = 1;
    this.prevRes = 1;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", this.applicationsPage);
    bodyData.append("on_page", this.applicationsOnPage);

    this.candidateSurname &&
      bodyData.append("filter[surname]", `%${this.candidateSurname.trim()}%`);

    this.candidateStatusesInStore &&
      Object.entries(this.candidateStatusesInStore).forEach((item) => {
        item[1] === true && bodyData.append("filter[status_id][]", item[0]);
      });

    this.sort && bodyData.append("sort", this.sort);
    this.sorted && bodyData.append("sorted", this.sorted);

    // формируем фильтр
    for (const prop in this.filter) {
      if (this.filter[prop].length) {
        for (const id of this.filter[prop]) {
          switch (prop) {
            case "applicationsStatuses":
              bodyData.append("filter[status_id][]", id);
              break;
            case "vacancies":
              bodyData.append("filter[vacancy_id][]", id);
              break;
            case "education_centers":
              bodyData.append("filter[education_center_id][]", id);
              break;
            default:
              return;
          }
        }
      }
    }

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies_candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["vacancies_candidates"] !== -1) {
            this.applications = response["vacancies_candidates"];
            this.applicationsCountAll = response["all_records"];
          } else {
            this.errorMessage = "Ничего не найдено";
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  showMoreApplications = async () => {
    this.isLoading = true;
    this.errorMessage = "";
    this.applicationsPage = this.applicationsPage += 1;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", this.applicationsPage);
    bodyData.append("on_page", this.applicationsOnPage);

    this.candidateSurname &&
      bodyData.append("filter[surname]", `%${this.candidateSurname}%`);

    this.candidateStatusesInStore &&
      Object.entries(this.candidateStatusesInStore).forEach((item) => {
        item[1] === true && bodyData.append("filter[status_id][]", item[0]);
      });

    this.sort && bodyData.append("sort", this.sort);
    this.sorted && bodyData.append("sorted", this.sorted);

    // формируем фильтр
    for (const prop in this.filter) {
      if (this.filter[prop].length) {
        for (const id of this.filter[prop]) {
          switch (prop) {
            case "applicationsStatuses":
              bodyData.append("filter[status_id][]", id);
              break;
            case "vacancies":
              bodyData.append("filter[vacancy_id][]", id);
              break;
            case "education_centers":
              bodyData.append("filter[education_center_id][]", id);
              break;
            default:
              return;
          }
        }
      }
    }

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies_candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
            this.isLoading = false;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["vacancies_candidates"] !== -1) {
            this.applications = [
              ...this.applications,
              ...response["vacancies_candidates"]
            ];
            this.applicationsCountAll = response["all_records"];
            this.prevRes = 1;
          } else {
            this.prevRes = -1;
          }
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  getApplicationsForCandidate = async (data) => {
    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("page", data.page);
    bodyData.append("on_page", data.on_page);

    data.candidate_id &&
      bodyData.append("filter[candidate_id]", data.candidate_id);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/getdata?action=vacancies_candidates`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => { });
        }
      })
      .then((response) => {
        runInAction(() => {
          if (response["vacancies_candidates"] !== -1) {
            this.applications = [
              ...this.applications,
              ...response["vacancies_candidates"]
            ];
          }
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  getSettings = async () => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    return fetch(`${baseUrl}/crm/massrecruitment/api/getdata?action=settings`, {
      method: "POST",
      headers: {
        "ACCESS-TOKEN": this.rootStore.usersStore.token
      },
      body: bodyData
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
          });
        }
      })
      .then((response) => {
        runInAction(() => {
          this.applicationsStatuses = response["vacancies_candidates_statuses"];
          this.education_centers = response["education_centers"];

          this.statusesTitles = {};

          for (const prop in response["candidates_statuses"]) {
            this.statusesTitles[prop] =
              response["candidates_statuses"][prop]["title"];
          }

          Object.entries(this.applicationsStatuses).forEach((status) => {
            const id = status[0];
            this.candidateStatusesNames[id] = status[1]["title"];
            this.candidateStatusesInStore[id] = false;
          });

          this.applicationAcceptedId =
            response["vacancies_candidates_statuses_func"]["approved"];

          this.requiredFieldsForAdd = {
            resident: response.required.candidate.resident.fields.add,
            non_resident: response.required.candidate.non_resident.fields.add
          };

          this.requiredFieldsForUpdate = {
            resident: response.required.candidate.resident.fields.update,
            non_resident: response.required.candidate.non_resident.fields.update
          };

          this.requiredFiles = {
            resident: response.required.candidate.resident.files,
            non_resident: response.required.candidate.non_resident.files
          };

          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  addCandidateMinimal = async (data) => {
    let bodyCredentials = new FormData();

    this.errorAddition = "";
    this.errorAdditionFields = {};
    this.error = false;

    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("phone", data.phone.replace(/[^\d]+/g, ""));
    bodyCredentials.append("surname", data.surname);
    bodyCredentials.append("name", data.name);
    bodyCredentials.append("birthday", data.birthday);
    data.email && bodyCredentials.append("email", data.email);
    data.patronymic && bodyCredentials.append("patronymic", data.patronymic);

    if (data.hasConviction === "Нет") {
      bodyCredentials.append("conviction", "Нет");
    } else {
      bodyCredentials.append("conviction", data.conviction);
    }

    try {
      const response = await fetch(
        `${baseUrl}/crm/massrecruitment/api/setdata?action=candidates_add`,
        {
          method: "POST",
          headers: {
            "ACCESS-TOKEN": this.rootStore.usersStore.token
          },
          body: bodyCredentials
        }
      );

      if (!response.ok) {
        const parsed = await parseFetchErrorResponse(response);
        runInAction(() => {
          this.error = true;
          this.errorAdditionFields = parsed.fieldErrors || {};
          this.errorAddition =
            parsed.message ||
            pickAnyFieldError(parsed.fieldErrors) ||
            "Не удалось зарегистрировать кандидата. Попробуйте ещё раз.";
        });
        return false;
      }

      const json = await response.json();
      runInAction(async () => {
        if (json && json["candidate_id"]) {
          this.selectedCandidate = json["candidate_id"];
          this.getCandidates();
          await this.getOneCandidate(json["candidate_id"]);
          this.cleanErrorAddition();
          this.setIsNewCandidate(false);
        } else {
          this.error = true;
          this.errorAddition =
            "Не удалось зарегистрировать кандидата. Попробуйте ещё раз.";
        }
      });
      return Boolean(json && json["candidate_id"]);
    } catch {
      runInAction(() => {
        this.error = true;
        this.errorAddition =
          "Не удалось зарегистрировать кандидата. Попробуйте ещё раз.";
      });
      return false;
    }
  };

  deleteCandidate = async () => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);
    bodyData.append("candidate_id", this.selectedCandidate);
    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=candidates_remove`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          runInAction(() => {
            this.error = true;
          });
        }
      })
      .then(() => {
        runInAction(() => {
          this.getCandidates();
          this.isLoading = false;
        });
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  sendCandidateOnVacancy = async (data) => {
    this.isLoading = true;

    let bodyData = new FormData();
    bodyData.append("access_key", access_key);

    bodyData.append("candidate_id", data.candidate_id);
    bodyData.append("vacancy_id", data.vacancy_id);
    bodyData.append("date_arrival", data.date_arrival);
    bodyData.append("education_center_id", data.education_center_id);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=vacancies_candidates_add`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.errors) {
          runInAction(() => {
            this.errorWithoutDate = errors[response.errors]
              ? errors[response.errors]
              : "Что-то пошло не так...";
            this.isLoading = false;
          });
        } else {
          runInAction(() => {
            this.getApplications();
            this.isLoading = false;
          });
        }
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
          this.isLoading = false;
        });
      });
  };

  refreshCandidateOnVacancy = async (data) => {
    let bodyData = new FormData();
    bodyData.append("access_key", access_key);

    data.vacancy_candidate_id &&
      bodyData.append("vacancy_candidate_id", data.vacancy_candidate_id);
    data.vacancy_id && bodyData.append("vacancy_id", data.vacancy_id);
    data.date_arrival && bodyData.append("date_arrival", data.date_arrival);
    data.education_center_id &&
      bodyData.append("education_center_id", data.education_center_id);

    return fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=vacancies_candidates_update`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyData
      }
    )
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.errors) {
          runInAction(() => {
            this.errorWithoutDate = errors[response.errors]
              ? errors[response.errors]
              : "Что-то пошло не так...";
          });
        } else {
          runInAction(() => {
            this.getApplications();
          });
        }
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      });
  };

  // Обновление отклика через кнопку "Обновить отклик": вакансия, УЦ и дата.
  // last_update и поднятие отклика в топ бэк проставляет сам при update.
  updateApplication = async (data) => {
    await this.refreshCandidateOnVacancy(data);
    // список перечитываем после ответа, чтобы показать актуальный last_update
    await this.getApplications();
  };

  refreshUserDataCandidate = async (data) => {
    this.isLoading = true;
    this.errorAddition = "";
    this.errorAdditionFields = {};

    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("id", data.id);

    bodyCredentials.append("email", data.email);
    bodyCredentials.append("phone", data.phone.replace(/[^\d]+/g, ""));

    bodyCredentials.append("surname", data.surname);
    bodyCredentials.append("name", data.name);
    bodyCredentials.append("patronymic", data.patronymic);
    bodyCredentials.append("birthday", data.birthday);
    bodyCredentials.append("non_resident", data.non_resident);
    bodyCredentials.append("registration", data.registration);

    if (data.hasConviction === "Нет") {
      bodyCredentials.append("conviction", "Нет");
    } else {
      bodyCredentials.append("conviction", data.conviction);
    }

    bodyCredentials.append("region_of_residence", data.region_of_residence);
    bodyCredentials.append("birth_place", data.birth_place);
    bodyCredentials.append("passport_code", data.passport_code);
    data.passport_date !== "" &&
      bodyCredentials.append("passport_date", data.passport_date);
    bodyCredentials.append("passport_place", data.passport_place);
    bodyCredentials.append("passport_number", data.passport_number);
    bodyCredentials.append("passport_series", data.passport_series);

    bodyCredentials.append("passport_propiska", data.passport_propiska);
    bodyCredentials.append("snils", data.snils);
    bodyCredentials.append("inn", data.inn);

    try {
      const response = await fetch(
        `${baseUrl}/crm/massrecruitment/api/setdata?action=candidates_update`,
        {
          method: "POST",
          headers: {
            "ACCESS-TOKEN": this.rootStore.usersStore.token
          },
          body: bodyCredentials
        }
      );

      if (!response.ok) {
        const parsed = await parseFetchErrorResponse(response);
        runInAction(() => {
          this.errorAdditionFields = parsed.fieldErrors || {};
          this.errorAddition =
            parsed.message ||
            pickAnyFieldError(parsed.fieldErrors) ||
            "Не удалось обновить кандидата. Попробуйте ещё раз.";
          this.isLoading = false;
        });
        return false;
      }

      try {
        const text = await response.text();
        const json = safeJsonParse(text);
        if (json) {
          const normalized = normalizeBackendErrorPayload(json);
          if (
            (normalized.fieldErrors && Object.keys(normalized.fieldErrors).length) ||
            normalized.message
          ) {
            runInAction(() => {
              this.errorAdditionFields = normalized.fieldErrors || {};
              this.errorAddition =
                normalized.message ||
                pickAnyFieldError(normalized.fieldErrors) ||
                "Не удалось обновить кандидата. Попробуйте ещё раз.";
              this.isLoading = false;
            });
            return false;
          }
        }
      } catch {
        //  for successful responses
      }

      runInAction(() => {
        this.isLoading = false;
      });

      runInAction(async () => {
        await this.getCandidates();
        if (this.openVacancies) {
          this.rootStore.modalWindows.setModalShowCandidate(false);
          this.rootStore.modalWindows.setModalShowVacancies(true);
        } else {
          this.rootStore.modalWindows.setModalShowCandidate(false);
        }
        this.openVacancies = false;
      });
      if (data.close) {
        this.rootStore.modalWindows.setIsCandidateModalOpen(false);
      }
      return true;
    } catch {
      runInAction(() => {
        this.error = true;
        this.isLoading = false;
        this.errorAddition = "Не удалось обновить кандидата. Попробуйте ещё раз.";
      });
      return false;
    }
  };

  getOneCandidate = async (id) => {
    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("candidate_id", id);

    try {
      const response = await fetch(
        `${baseUrl}/crm/massrecruitment/api/getdata?action=candidates_one`,
        {
          method: "POST",
          headers: {
            "ACCESS-TOKEN": this.rootStore.usersStore.token
          },
          body: bodyCredentials
        }
      );

      if (!response.ok) {
        const parsed = await parseFetchErrorResponse(response);
        runInAction(() => {
          this.errorAdditionFields = parsed.fieldErrors || {};
          this.errorAddition =
            parsed.message ||
            pickAnyFieldError(parsed.fieldErrors) ||
            "Не удалось получить данные кандидата. Попробуйте ещё раз.";
        });
        return;
      }

      const json = await response.json();
      if (json.cadidate !== -1) {
        runInAction(() => {
          this.oneCandidateData = json.cadidate;
          this.oneCandidateFiles = json.files;
        });
      } else {
        runInAction(() => {
          this.errorAdditionFields = {};
          this.errorAddition = "Кандидат не найден.";
        });
      }
    } catch {
      runInAction(() => {
        this.error = true;
      });
    }
  };

  updateVacancyCandidateTime = async (ids) => {
    this.isUpdateLoading[ids] = true;
    let bodyCredentials = new FormData();
    bodyCredentials.append("access_key", access_key);
    bodyCredentials.append("vacancy_candidate_ids[]", ids);

    await fetch(
      `${baseUrl}/crm/massrecruitment/api/setdata?action=vacancies_candidates_update_time`,
      {
        method: "POST",
        headers: {
          "ACCESS-TOKEN": this.rootStore.usersStore.token
        },
        body: bodyCredentials
      }
    )
      .then((res) => {
        if (res.ok) {
          runInAction(() => {
            // Обновляем в UI данные по обновлению
            const currentCandidate = this.applications.find(
              (candidate) => candidate.vacancy_candidate_id === ids
            );
            if (currentCandidate) {
              // Преобразуем текущую дату в формат "YYYY-MM-DD HH:MM:SS"
              const now = new Date();
              const year = now.getFullYear();
              const month = String(now.getMonth() + 1).padStart(2, "0");
              const day = String(now.getDate()).padStart(2, "0");
              const hours = String(now.getHours()).padStart(2, "0");
              const minutes = String(now.getMinutes()).padStart(2, "0");
              const seconds = String(now.getSeconds()).padStart(2, "0");

              currentCandidate[
                "last_update"
              ] = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
          });
          return res.json();
        } else {
          runInAction(() => {
            if (res.status === 400) {
              this.errorAddition = "Ошибка при обновлении отклика.";
            } else {
              this.error = true;
            }
          });
        }
      })
      .catch(() => {
        runInAction(() => {
          this.error = true;
        });
      })
      .finally(() => {
        runInAction(() => {
          this.isUpdateLoading[ids] = false;
        });
      });
  };

  addOneCandidateDataValue = (key, value) => {
    runInAction(() => (this.oneCandidateData[key] = value));
  };

  clearCandidatesForVacancy = () => {
    runInAction(() => (this.candidatesForVacancy = []));
  };

  getInitialValues = (oneCandidateData) => {
    return {
      surname: oneCandidateData ? oneCandidateData.surname || "" : "",
      name: oneCandidateData ? oneCandidateData.name || "" : "",
      patronymic: oneCandidateData ? oneCandidateData.patronymic || "" : "",
      birth_place: oneCandidateData ? oneCandidateData.birth_place || "" : "",
      non_resident: oneCandidateData
        ? oneCandidateData.non_resident || "0"
        : "0",
      registration: oneCandidateData ? oneCandidateData.registration || "" : "",
      region_of_residence: oneCandidateData
        ? oneCandidateData.region_of_residence || ""
        : "",
      passport_propiska: oneCandidateData
        ? oneCandidateData.passport_propiska || ""
        : "",
      hasConviction:
        oneCandidateData?.conviction === "Нет" ||
          oneCandidateData?.conviction === "undefined" ||
          oneCandidateData?.conviction === "" ||
          !oneCandidateData?.conviction
          ? "Нет"
          : "Есть",
      conviction:
        oneCandidateData?.conviction === "Нет" ||
          oneCandidateData?.conviction === "undefined" ||
          oneCandidateData?.conviction === "" ||
          oneCandidateData?.conviction === ""
          ? "Нет"
          : oneCandidateData?.conviction,

      birthday: oneCandidateData ? oneCandidateData.birthday || "" : "",
      phone: oneCandidateData ? oneCandidateData.phone || "7" : "7",
      email: oneCandidateData ? oneCandidateData.email || "" : "",
      passport_number: oneCandidateData
        ? oneCandidateData.passport_number || ""
        : "",
      passport_series: oneCandidateData
        ? oneCandidateData.passport_series || ""
        : "",
      passport_code: oneCandidateData
        ? oneCandidateData.passport_code || ""
        : "",
      passport_date: oneCandidateData
        ? oneCandidateData.passport_date || ""
        : "",
      passport_place: oneCandidateData
        ? oneCandidateData.passport_place || ""
        : "",
      snils: oneCandidateData ? oneCandidateData.snils || "" : "",
      inn: oneCandidateData ? oneCandidateData.inn || "" : ""
    };
  };
}
